import type { TypeToken } from "../di";

export interface WorkspaceFileMetadata {
  readonly key: string;
  readonly fileId: string;
  readonly filename: string;
  readonly contentType: string;
  readonly size: number;
  readonly lastModified: Date;
}

export interface IWorkspaceFileStorage {
  listFiles(filenameFilter?: string): Promise<ReadonlyArray<WorkspaceFileMetadata>>;

  getFileByName(filename: string): Promise<WorkspaceFileMetadata>;

  getFileById(fileId: string): Promise<WorkspaceFileMetadata>;

  getStream(key: string): Promise<ReadableStream<Uint8Array>>;

  writeFile(filename: string, body: Uint8Array, contentType: string): Promise<WorkspaceFileMetadata>;
}

export class WorkspaceFileNotFoundError extends Error {
  constructor(readonly key: string) {
    super(`Workspace file not found: ${key}`);
    this.name = "WorkspaceFileNotFoundError";
  }
}

export interface IWorkspaceFileRegistrar {
  register(meta: WorkspaceFileMetadata): Promise<void>;
}

export const WorkspaceFileStorageToken = Symbol.for("codemation.core.WorkspaceFileStorage") as TypeToken<
  IWorkspaceFileStorage | undefined
>;

export const WorkspaceFileRegistrarToken = Symbol.for("codemation.core.WorkspaceFileRegistrar") as TypeToken<
  IWorkspaceFileRegistrar | undefined
>;
